import Overlay from 'ol-ext/control/Overlay';
import './animate.css'
var html;
$.get("animate.html", function (result) {
     html = result;
//     text = $(result).text();
console.log(html);
var animOverlay = new Overlay ({ 
	closeBox : true, 
	className: "slide-right animOverlay", 
	content: html,
});
map.addControl(animOverlay);


// Display animOverlay overlay on first opening - i.e. before windows.animOverlay is set

if(sessionStorage.getItem('firstLoad')===null) {
//	sessionStorage.setItem('firstLoad',true);
	//alert(sessionStorage.getItem('firstLoad'));
	animOverlay.toggle();
}
sessionStorage.setItem('firstLoad',false);


window.animOverlay=animOverlay;
});

